import React from 'react';
import { FAQItem } from './FAQItem';
import faqs from '../assets/faqs.json';

export const FAQSection: React.FC = () => {
  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-subtitle">Everything you need to know about Copyright Clinic.</p>
        </div>
        <div className="faq-list">
          {faqs.map((faq) => (
            <FAQItem
              key={faq.id}
              question={faq.question}
              answer={faq.answer}
              bullets={faq.bullets}
              footer={faq.footer}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
